<sit-icon-button [alt]="'Asignar zona'" [icon]="Icon.location_w" [sizeClass]="'icon-size-22'" class="btn fx-cell-hover"
  (click)="dispatchAction(actions.ZONE)"></sit-icon-button>

<sit-icon-button [alt]="'Editar'" [icon]="Icon.edit_w" [sizeClass]="'icon-size-22'" class="btn fx-cell-hover pl-05"
  (click)="dispatchAction(actions.EDIT)"></sit-icon-button>
